// extracted by mini-css-extract-plugin
export default {"contentTitle":"G3HrYCqUrRcgSbo2Yof7"};